import React from 'react';
import { Globe } from 'lucide-react';
import { TIMEZONE_OPTIONS, tzOffsetLabel, useUserTimezone } from 'utils/userTimezone';

// Slim app-wide notice shown only when the user's saved display timezone has
// a different UTC offset to their device clock (e.g. travelling).
export const TimezoneBanner = () => {
  const tz = useUserTimezone();
  if (!tz) return null;
  const zoneLabel = tzOffsetLabel(tz);
  const offMin = -new Date().getTimezoneOffset();
  const sign = offMin >= 0 ? '+' : '-';
  const abs = Math.abs(offMin);
  const deviceLabel = `UTC${sign}${Math.floor(abs / 60)}${abs % 60 ? ':' + String(abs % 60).padStart(2, '0') : ''}`;
  if (!zoneLabel || zoneLabel === deviceLabel) return null;
  const cityName = TIMEZONE_OPTIONS.find(o => o.value === tz)?.label || tz;
  return (
    <div
      className="w-full bg-amber-50 border-b border-amber-200 text-amber-800 text-xs px-3 py-1 flex items-center justify-center gap-1.5"
      data-testid="timezone-banner"
    >
      <Globe className="h-3 w-3 shrink-0" />
      <span>
        Showing times in <strong>{cityName} ({zoneLabel})</strong> — your device is on {deviceLabel}
      </span>
    </div>
  );
};

export default TimezoneBanner;
